<mat-card class="gymfinder-card">
  <mat-card-header class="gymfinder-card-header">
    <mat-card-title>Generate Gym Report</mat-card-title>
  </mat-card-header>

  <mat-card-content class="gymfinder-card-content">
    <div class="file-upload-container">
      <gymfinder-file-upload
        title="Gym Upload"
        (fileNameChanged)="onGymFileChanged($event)"></gymfinder-file-upload>
      <gymfinder-file-upload
        title="Lead Upload"
        (fileNameChanged)="onLeadFileChanged($event)"></gymfinder-file-upload>
    </div>

    <div>
      <mat-form-field class="form-column">
        <mat-label>Report Name</mat-label>
        <input
          matInput
          type="string"
          placeholder="Gym_Report"
          [(ngModel)]="reportNameValue" />
      </mat-form-field>
    </div>

    <div>
      <button
        mat-raised-button
        color="primary"
        class="generate-button"
        (click)="generateReport()"
        [disabled]="!canGenerateReport()">
        <mat-icon>join_full</mat-icon>
        Generate Report
      </button>
    </div>

    <mat-progress-bar
      class="file-progress-bar"
      mode="determinate"
      [value]="progressbarValue"></mat-progress-bar>
    <mat-hint [textContent]="hintMessage"></mat-hint>
  </mat-card-content>
</mat-card>
